/* eslint-disable @typescript-eslint/naming-convention */
import { Card, CardBody, FormControl, FormErrorMessage, FormLabel, Input, TabPanel, VStack } from '@chakra-ui/react'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

import { CaptainSwitch, ShirtNumberField } from './FormFields'
import { PlayerCardHeader } from './PlayerCardHeader'

export function FakePlayerTabPanel() {
    const { newPlayer, isSurnameInvalid, isFrontFakePlayer, patchPlayer, isSubstitute } = useAddPlayerContext()

    return (
        <TabPanel px={0}>
            <Card size="md">
                {!isFrontFakePlayer && <PlayerCardHeader />}
                <CardBody pt={!isFrontFakePlayer ? 0 : undefined}>
                    <VStack spacing={4}>
                        <FormControl isRequired isInvalid={isSurnameInvalid}>
                            <FormLabel>Full Name</FormLabel>
                            <Input
                                className="player-surname-input"
                                value={newPlayer?.surname ?? ''}
                                placeholder="Full Name"
                                onChange={e => patchPlayer({ surname: e.target.value })}
                            />
                            {isSurnameInvalid && <FormErrorMessage>Full Name is required.</FormErrorMessage>}
                        </FormControl>
                        <ShirtNumberField />

                        {!isSubstitute && <CaptainSwitch />}
                    </VStack>
                </CardBody>
            </Card>
        </TabPanel>
    )
}
